import React from 'react';
import styled from 'styled-components/macro';
import { ButtonRow, SecondaryButton } from '../../shared/Button';
import { Header3 } from '../../shared/Headers';
import { Modal } from '../../shared/Modal';
import { spacingS, spacingXS } from '../../styling/spacing';

type ChangeLineManagerModalProps = {
  closeModal: () => void;
  isOpen: boolean;
};

export const ChangeLineManagerModal = ({ closeModal, isOpen }: ChangeLineManagerModalProps) => {
  return (
    <Modal isOpen={isOpen} contentLabel="change line manager modal" onRequestClose={closeModal}>
      <ModalContentContainer>
        <Header3>Change Line Manager</Header3>
        <TextContainer>
          <p>Line managers cannot currently be updated through FISH.</p>
          <p>If the information shown here is incorrect please contact helpdesk.</p>
          <p>
            Azure AD admins can change line management by following{' '}
            <a href="https://dovestones.com/setting-manager-attribute/">these instructions</a>.
          </p>
        </TextContainer>
        <ButtonRow>
          <SecondaryButton onClick={closeModal}>Close</SecondaryButton>
        </ButtonRow>
      </ModalContentContainer>
    </Modal>
  );
};

const ModalContentContainer = styled.div`
  margin: ${spacingS};
`;

const TextContainer = styled.div`
  margin: ${spacingXS} 0;
`;
